
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/i-vini",
      function () {
        return require("private-next-pages/i-vini.js");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/i-vini"])
      });
    }
  